/**
 * @file PreviewSkeletonVerticalCard.tsx
 * @description Enhanced skeleton for PreviewRail with animated gradient
 *
 * Features:
 * - Moving gradient animation with vibrant colors
 * - Blends with standard animate-pulse for subtle shimmer effect
 * - Uses CSS custom properties for smooth color transitions
 */

import type { ReactElement } from "react";
export function PreviewSkeletonVerticalCard(): ReactElement {
  return (
    <div className="flex-shrink-0 self-start w-[calc(100vw-3rem)] sm:w-[400px] snap-center">
      {/* Shadow wrapper matching TitleCard */}
      <div className="shadow-[0_10px_40px_rgba(0,0,0,0.7)]">
        <div className="aspect-[2/3] rounded-lg overflow-hidden relative bg-neutral-900">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/30 via-purple-800/40 to-pink-900/30" />
        </div>
      </div>
    </div>
  );
}
